/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 08:51:30
 * @LastEditTime: 2020-09-27 09:38:06
 * @Description: 客户store
 */
import {
  getCommentList,
  updateComment,
  deleteComment,
  createComment,
  getCommentById
} from '@/api/comment'
import Vue from 'vue'

const state = {
  commentList: [],
  totalCounts: 0,
}

const actions = {
  async getCommentsAction({
    commit
  }, payload) {
    try {
      const res = await getCommentList(payload)
      commit('SET_COMMENT_LIST', res.data);
      return res.data.commentList
    } catch (error) {
      throw error
    }
  },
  // async getCommentByIdAction({ commit }, id) {
  //     try {
  //         const comment = await getCommentById(id)
  //         commit('SET_SELECT_Comment', comment.data);
  //         return comment.data
  //     } catch (error) {
  //         throw error.message
  //     }
  // },
  async createCommentAction({
    commit
  }, payload) {
    try {
      const newComment = await createComment(payload);
      commit('ADD_COMMENT', newComment.data)
      return newComment
    } catch (error) {
      throw error
    }
  },
  // async updateCommentAction({ commit }, payload) {
  //     try {
  //         const newComment = await updateComment(payload.id, payload.data);
  //         commit('UPDATEComment', newComment.data)
  //         return newComment.data
  //     } catch (error) {
  //         throw error
  //     }
  // },
  // async deleteCommentAction({ commit }, payload) {
  //     try {
  //         await deleteComment(payload.id)
  //         commit('DELETEComment', payload.id)
  //         return payload.id
  //     } catch (error) {
  //         throw error
  //     }
  // }
}

const mutations = {
  SET_COMMENT_LIST(state, payload) {
    state.commentList = payload.receiveList
    state.totalCounts = payload.totalCounts
  },
  // SET_Comment_SIMPLE_LIST(state, payload) {
  //     state.commentsSimple = payload.commentList
  // },
  // SET_USER_Comment_ROLES_COUNT(state, payload) {
  //     state.userCommentRolesCount = payload
  // },
  // SETCANAPPLYCommentLIST(state, payload) {
  //     state.comments = payload.commentList.filter(x => {return !x.hasOwnProperty('commentDevelop')} )
  //     state.totalCounts = payload.totalCounts
  // },
  // // 修改 客户详情页列表的state
  // SETDETAILCommentLIST(state, payload) {
  //     state.detailComments = payload.commentList
  //     state.totalCounts = payload.totalCounts
  // },
  ADD_COMMENT(state, comment) {
    state.commentList.unshift(comment)
    state.totalCounts++
  },
  // UPDATEComment(state, comment) {
  //     Vue.set(state.comments, state.comments.findIndex(x => x._id === comment._id), comment);
  //     state.selectComment = comment
  // },
  // DELETEComment(state, id) {
  //     state.comments = state.comments.filter(e => e._id !== id)
  //     state.totalCounts--
  // },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}